<script setup lang="ts">
/**
 * BackLink.vue — Cyberpunk 霓虹返回按钮
 * - props: { label: string; to: string }
 * - 内部 useRouter + button click 触发 router.push(to)
 * - 渐变 CTA 底 + 霓虹光晕，hover 提亮 + 微上移
 * - 箭头走 lucide:arrow-left（YfbIcon 包装，与 v5 扩展禁用 emoji/Unicode 符号的规范一致）
 */
import { useRouter } from 'vue-router'
import YfbIcon from '@/components/YfbIcon.vue'

const props = defineProps<{
  label: string
  to: string
}>()

const router = useRouter()

function handleClick() {
  router.push(props.to)
}
</script>

<template>
  <button
    type="button"
    class="back-link yfb-press"
    :aria-label="label"
    @click="handleClick"
  >
    <YfbIcon name="lucide:arrow-left" :size="14" />
    <span>{{ label }}</span>
  </button>
</template>

<style scoped>
.back-link {
  display: inline-flex;
  align-items: center;
  gap: calc(var(--yfb-sp-1) + var(--yfb-sp-1) / 2);
  padding: var(--yfb-sp-2) var(--yfb-sp-4);
  background-image: var(--yfb-grad-cta);
  color: var(--yfb-on-accent);
  border: 1px solid var(--yfb-rule);
  border-radius: var(--yfb-radius-md);
  box-shadow: 0 0 12px var(--yfb-glow);
  font-family: var(--yfb-font-ui);
  font-size: var(--yfb-fs-sm);
  font-weight: 700;
  letter-spacing: var(--yfb-ls-mono);
  cursor: pointer;
  transition: transform var(--yfb-anim-fast) ease-out,
              box-shadow var(--yfb-anim-fast) ease-out,
              filter var(--yfb-anim-fast) ease-out;
}

.back-link:hover {
  filter: brightness(1.08);
  transform: translateY(-1px);
  box-shadow: 0 0 20px var(--yfb-glow), 0 0 32px var(--yfb-glow-2);
}

.back-link:focus-visible {
  outline: 2px solid var(--yfb-focus);
  outline-offset: 2px;
}
</style>